<template>
  <div class="all newsContainer">
    <div class="news-right">
      <h1 class="news-title">新闻中心</h1>
      <!-- <h3>-- 集团公告</h3> -->
      <p class="line"></p>
      <div class="news">
        <div
          v-if="arr.length == 0"
          style="text-align: center;font-size: 16px;color: #999;"
        >
          暂无数据~
        </div>
        <div v-for="person in arr" :key="person.resourceId">
          <router-link
            class="news-box"
            :to="{
              path: '/newsdetailed',
              query: { id: `${person.resourceId}`, path: 'newlist2' }
            }"
          >
            <!-- <router-link class="news-box" :to="{path:`/newsdetailed/${person.resourceId}`}"> -->
            <div class="news-date">
              <p>{{ person.createTime.slice(8, 10) }}</p>
              <p>{{ person.createTime.slice(0, 7) }}</p>
              <p></p>
            </div>
            <div class="news-text">
              <h2>{{ person.title }}</h2>
              <p>{{ person.limitContent }}...</p>
            </div>
          </router-link>
        </div>
      </div>

      <div class="pages">
        <el-pagination
          v-if="arr.length !== 0"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :pager-count="5"
          :current-page="pageNum"
          :page-size="pageSize"
          layout="prev, pager, next, jumper"
          :total="pageTotal"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "newlist2",
  data() {
    return {
      status: 1,
      type: 1,
      arr: [],
      regex: /(<([^>]+)>)/gi,
      pageNum: 1, //页数
      pageSize: 4, //每页显示
      pageTotal: 0 //总共
    };
  },
  mounted() {
    this.select();
  },
  methods: {
    handleSizeChange(pageSize) {
      this.pageSize = pageSize;
      this.select();
    },
    handleCurrentChange(pageNum) {
      this.pageNum = pageNum;
      this.select();
    },
    select() {
      this.request
        .get(`/${this.status}/${this.type}`, {
          params: {
            pageSize: 4,
            category: "集团公告",
            pageNum: this.pageNum
          }
        })
        .then(res => {
          this.arr = res.data.data;
          this.pageTotal = res.data.total;
          for (var i = 0; i < this.arr.length; i++) {
            this.arr[i].content = this.getSimpleText(this.arr[i].content);
            console.log(this.arr[i].content + "!!!!!");
          }
        });
    },
    getSimpleText(html) {
      const re1 = new RegExp("<.+?>", "g"); // 匹配html标签的正则表达式，"g"是搜索匹配多个符合的内容
      const arrEntities = {
        lt: "<",
        gt: ">",
        nbsp: " ",
        amp: "&",
        quot: '"',
        ldquo: "“",
        mdash: "—",
        rdquo: "”"
      };
      return html
        .replace(re1, "")
        .replace(/&(lt|gt|nbsp|amp|quot|ldquo|mdash|rdquo);/gi, function(
          all,
          t
        ) {
          return arrEntities[t];
        });
    }
  }
};
</script>
<style scoped>
.all {
  width: 1110px;
}
.news-right {
  /* width:1138px; */
  margin-left: 65px;
  min-height: 1053px;
}

.news-right h1 {
  margin-bottom: 16.992px;
  font-size: 29px;
  color: #140047;
  line-height: 52px;
  letter-spacing: 1.92px;
}
.news-right h3 {
  margin-left: 134px;
  margin-top: -46px;
  font-size: 20px;
  color: #140047;
  letter-spacing: 1.92px;
}
.news-right .line {
  margin-bottom: 32.0064px;
  width: 100%;
  height: 1.9968px;
  background: #efeff2;
  opacity: 0.5;
}
.news .news-box {
  margin-bottom: 25.9968px;
  display: flex;
  width: 100%;
  box-shadow: 0rem 0.9984px 10.0032px 0rem rgba(176, 183, 213, 0.2);
  transition: transform 0.3s;
  cursor: pointer;
}
.news .news-box:hover {
  transform: scale(1.005);
  box-shadow: 0rem 4.992px 20.0064px 0rem rgba(176, 183, 213, 0.2);
}
.news .news-box:last-child {
  margin-bottom: 60px;
}
.news-box .news-date {
  padding: 49px 36px;
  border-right: 0.9984px solid #ecf0f2;
}
.news-date p:nth-child(1) {
  margin-bottom: 0.1px;
  font-size: 36px;
  font-weight: bold;
  color: #1d1d1d;
  line-height: 42px;
  letter-spacing: 1.92px;
}
.news-date p:nth-child(2) {
  margin-bottom: 3px;
  font-size: 12px;
  font-weight: bold;
  color: #1d1d1d;
  opacity: 0.5;
  line-height: 19px;
  letter-spacing: 0.96px;
  white-space: nowrap;
  opacity: 0.22;
}
.news-date p:nth-child(3) {
  width: 16px;
  height: 2px;
  background: #ffa200;
}
.news-box .news-text {
  padding: 45px 40px;
}
.news-text h2 {
  margin-bottom: 16px;
  font-size: 14px;
  font-weight: 600;
  color: #1d1e20;
  line-height: 25px;
  letter-spacing: 0.96px;
}
.news-text p {
  /* width:800px; */
  height: 30px;
  overflow: hidden;
  font-size: 12px;
  font-weight: 400;
  color: rgba(29, 29, 29, 0.44);
  line-height: 15px;
  letter-spacing: 0.96px;
}
.news-right .pages {
  margin: 0 auto;
  display: flex;
  width: 600px;
  justify-content: space-between;
  align-items: center;
}
.news-right .pages {
  display: flex;
}
.pages button {
  width: 32.0064px;
  height: 32.0064px;
  background: transparent;
  border-radius: 6.0096px;
  border: 0.9984px solid #dddddd;
  font-size: 13.9968px;
  color: #666666;
  line-height: 22.0032px;
  transition: background-color 0.3s;
}
.pages button:first-child .img {
  width: 10.0032px;
  height: 13.9968px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng7bd3b3ca78332483ef7acdff03f316330bc26ef98ca1d55de2428c1359e2bda5)
    100% no-repeat;
  background-size: 100% 100%;
}
.pages button:nth-child(12) .img {
  width: 10.0032px;
  height: 13.9968px;
  background: url(https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng7bd3b3ca78332483ef7acdff03f316330bc26ef98ca1d55de2428c1359e2bda5)
    100% no-repeat;
  background-size: 100% 100%;
  transform: rotateY(180deg);
}
.pages button:hover {
  color: white;
  background-color: #140047;
}
.pages div {
  width: 20.0064px;
  margin: 0 10.0032px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.pages div span {
  width: 3.9936px;
  height: 3.9936px;
  background: #dddddd;
  border-radius: 3.9936px;
}
.pages p {
  margin-left: 15.9936px;
  display: flex;
  align-items: center;
}
.pages p input {
  margin: 0 8.0064px;
  width: 48px;
  height: 32.0064px;
  background: transparent;
  border-radius: 3.9936px;
  border: 0.9984px solid #dddddd;
}
</style>



// WEBPACK FOOTER //
// src/components/newlist2.vue